/* eslint-disable react/require-default-props */
import React from 'react';
import { Tag } from '../../atoms/Tag';
import { Tooltip } from '../../atoms/Tooltip';
import './TagsListStyles.scss';
/**
 * TagsList component for displaying multiple tags
 *
 * @example
 * ```tsx
 * <TagsList
 *   tags={[
 *     { id: 1, label: 'Important', variant: 'red' },
 *     { id: 2, label: 'Feature', variant: 'blue' }
 *   ]}
 *   onRemove={(id) => console.log('Removed tag', id)}
 * />
 * ```
 */
export function TagsList({ tags, onRemove, readOnly = false, colorStyle = 'solid', variant = 'base', tooltipProps, className }) {
    // Base variant - normal tags list
    if (variant === 'base') {
        return (React.createElement("div", { className: `qmb-ui-tags-list ${className || ''}` }, tags.map((tag) => (React.createElement(Tag, { key: tag.id, label: tag.label, variant: tag.variant || 'gray', colorStyle: colorStyle, readOnly: readOnly, onRemove: onRemove ? () => onRemove(tag.id) : undefined })))));
    }
    // Compact variant - show dots with tooltip
    const compactTagsList = (React.createElement("div", { className: `qmb-ui-tags-list qmb-ui-tags-list--compact ${className || ''}` }, tags.map((tag) => (React.createElement(Tag, { key: tag.id, label: tag.label, variant: tag.variant || 'gray', colorStyle: colorStyle, size: "compact", readOnly: true })))));
    // Wrap compact variant with tooltip showing full tags
    const tooltipContent = (React.createElement("div", { className: "qmb-ui-tags-list__tooltip-content" }, tags.map((tag) => (React.createElement(Tag, { key: tag.id, label: tag.label, variant: tag.variant || 'gray', colorStyle: colorStyle, readOnly: true })))));
    return (React.createElement(Tooltip, { content: tooltipContent, position: (tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.position) || 'top', delay: (tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.delay) || 200 }, compactTagsList));
}
